import { normalizeFilterSuids, setFilterSuids } from "./filterSuids";
import { SearchParamType } from "./types/SearchParamType";
export function normalizeJobCategorySuids(values) {
    return normalizeFilterSuids(values);
}
export function getJobCategorySuids(searchParams) {
    return normalizeJobCategorySuids(searchParams.getAll(SearchParamType.JOB_CATEGORY_SUID));
}
export function setJobCategorySuids(searchParams, values) {
    setFilterSuids(searchParams, SearchParamType.JOB_CATEGORY_SUID, normalizeJobCategorySuids(values));
}
